var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"public-title"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"text-box"},[(_vm.dataInfo.title)?_c('h4',{staticClass:"title",class:{
          large: _vm.size === 'large',
          left: _vm.site === 'left',
        },domProps:{"innerHTML":_vm._s(_vm.dataInfo.title)}}):_vm._e(),(_vm.dataInfo.desc)?_c('h5',{staticClass:"desc",domProps:{"innerHTML":_vm._s(_vm.dataInfo.desc)}}):_vm._e()])])])}
var staticRenderFns = []

export { render, staticRenderFns }